import React from 'react'

const OurWebsiteDevelopment = () => {
  return (
      <div
        className="overflow-hidden space"
        data-bg-src="assets/img/bg/choose_bg_2.jpg"
      >
        <div className="container th-container5">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="title-area text-center">
                <h2 className="sec-title text-black">
                  Our Website Development
                </h2>
              </div>
            </div>
          </div>
          <div className="choose-tabs-wrapper">
            <div
              className="nav nav-tabs choose-tabs-tabs"
              id="nav-tab"
              role="tablist"
            >
              <button
                className="nav-link active"
                id="nav-step1-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step1"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Website Development
              </button>
              <button
                className="nav-link"
                id="nav-step2-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step2"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Front-End Development
              </button>
              <button
                className="nav-link"
                id="nav-step3-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step3"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Back-End Development
              </button>
              <button
                className="nav-link"
                id="nav-step4-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step4"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Full-Stack Development
              </button>
              <button
                className="nav-link"
                id="nav-step5-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step5"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Build Your Online Store
              </button>
              <button
                className="nav-link"
                id="nav-step6-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step6"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Web Design & User Experience
              </button>
              <button
                className="nav-link"
                id="nav-step7-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step7"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Content Management Systems (CMS)
              </button>
              <button
                className="nav-link"
                id="nav-step8-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step8"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Web Application Development
              </button>
              <button
                className="nav-link"
                id="nav-step9-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-step9"
                type="button"
                style={{ padding: "5px 10px", margin: "5px" }}
              >
                Website Maintenance & Support
              </button>
            </div>
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-step1"
                role="tabpanel"
              >
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Website Development
                      </h5>
                      <p className="box-text text-white">
                        We provide comprehensive web development services,
                        focusing on the functionality and performance of the
                        website. Our solution is to provide a mobile responsive,
                        SEO optimised website to the users. Our website is
                        simple, with an aesthetic look for the user. Talk to our
                        expert in developing the best website for your business.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/normal/choose_img_1.jpg"
                      alt="Website Development"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step2" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Front-End Development
                      </h5>
                      <p className="box-text text-white">
                        We develop interactive, fast, and responsive front-end
                        interfaces for the users. Using a modern framework for
                        the development. We craft visually appealing and
                        user-interactive websites using reach, angular, nodejs,
                        php, and vue.js. Our goal is to provide visitors to the
                        site to improve engagement rate and higher chances of
                        conversion rates.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/normal/choose_img_2.jpg"
                      alt="Front-End Development"
                      title="Front-End Development"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step3" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Back-End Development
                      </h5>
                      <p className="box-text text-white">
                        Providing secure and scalable back-end development for
                        flawless functionality and integration. Our expert
                        back-end development team offers security to the
                        database, API, and server-side functionality. The robust
                        infrastructure supports the front-end experience. It is
                        a more reliable, efficient website for your business.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/normal/choose_img_3.jpg"
                      alt="Back-End Development"
                      title="Back-End Development"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step4" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Full-Stack Development
                      </h5>
                      <p className="box-text text-white">
                        A complete development solution for both front-end and
                        back-end technologies. By integrating both the
                        technologies in the system. Our full-stack development
                        services offer end-to-end solutions for the needs of the
                        business. The comprehensive approach ensures a smooth
                        digital experience for the users.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/normal/choose_img_4.jpg"
                      alt="Full-Stack Development"
                      title="Full-Stack Development"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step5" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Build Your Online Store
                      </h5>
                      <p className="box-text text-white">
                        By developing the scalable and user-friendly online
                        store for the business. Our professional experts develop
                        the best design for your online store. The experts
                        ensure the smooth functioning and integration of apps.
                        Like the payment gateway, product catalogs, and the
                        website. It helps to increase sales in the store. Our
                        custom-made solution helps to provide a smooth shopping
                        experience to the user. It helps in increasing the
                        revenue with the conversions. It increases the revenue
                        of the business with the best content writing management
                        system.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/icon/Online Store.avif"
                      alt="Online Store Development"
                      title="Online Store Development"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step6" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Web Design & User Experience
                      </h5>
                      <p className="box-text text-white">
                        Our web design services are mainly focused on
                        functionality, usability, and customer engagement. User
                        experience is the main element of the web design
                        services. Our expert develops aesthetics website which
                        focused on conversions, engagement and to identify brand
                        identity. It helps to connect with new target audiences
                        for improving effective online presence.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/icon/website.avif"
                      alt="Web Design & UX"
                      title="Web Design & UX"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step7" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Content Management Systems (CMS)
                      </h5>
                      <p className="box-text text-white">
                        We offer a user-friendly CMS platform like WordPress and
                        Shopify for easy content update and management. Our team
                        develops CMS based on platforms like WordPress, Shopify,
                        and Magento. It enables easy management and updating of
                        the content on the website. It maintains the accuracy of
                        the content without requiring any technical knowledge.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/icon/cms.jpg"
                      alt="CMS Development"
                      title="CMS Development"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step8" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Web Application Development
                      </h5>
                      <p className="box-text text-white">
                        Custom-tailored web app designs for the scalability and
                        efficiency of the website. Our professional team
                        develops custom-built web applications for improving
                        automation, customer interactions, and operational
                        efficiency. Our application is to develop solutions to
                        the challenges. To achieve the goals of the business and
                        to provide effective solutions.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/icon/mobile app.jpg"
                      alt="Web Application Development"
                      title="Web Application Development"
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="nav-step9" role="tabpanel">
                <div className="choose-wrapper">
                  <div className="choose-content">
                    <div className="title-area mb-30">
                      <h5 className="sec-title mb-3 text-white">
                        Website Maintenance & Support
                      </h5>
                      <p className="box-text text-white">
                        Ongoing website monitoring and security updates
                        improving performance optimization. We offer solutions
                        for the digital success of your business beyond the
                        development process. Our experts offer support, security
                        updates, performance monitoring, and troubleshooting.
                        They ensure the website remains secure and up-to-date
                        and performs optimizations all the time.
                      </p>
                    </div>
                  </div>
                  <div className="choose-image th-anim">
                    <img
                      loading="lazy"
                      src="assets/img/icon/software-code.avif"
                      alt="Website Maintenance & Support"
                      title="Website Maintenance & Support"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default OurWebsiteDevelopment
